import React from 'react';
import intl from '$intl';
import OrderModel from '$fbusiness/models/order';

import { ModalWrapper } from './styles';
import InvoiceModel from '$fbusiness/models/invoice';
import OrderShippingDetails from './orderShippingDetails';
import CurrentStateModel from '$fbusiness/models/currentState';
import FactoryModel from '$fbusiness/models/factory';

interface OrderModalProps {
  show: boolean;
  order?: OrderModel;
  invoice?: InvoiceModel;
  onSubmitOrder: Function;
  factory: FactoryModel;
  currentState: CurrentStateModel;
  onClose: () => void;
}

const OrderModal: React.FC<OrderModalProps> = ({
  show,
  order,
  currentState,
  invoice,
  factory,
  onClose,
  onSubmitOrder,
}) => {
  const titleKey = invoice ? 'TITLE_REGENERATE' : 'TITLE';

  return (
    <ModalWrapper
      titleText={intl('SCREEN.SHIPPING_MODAL.' + titleKey, { orderId: order?.orderId })}
      show={show}
      width="740px"
      onClose={() => onClose()}
      useCustom>
      {(order || invoice) && (
        <OrderShippingDetails
          order={order}
          invoice={invoice}
          factory={factory}
          onClose={onClose}
          currentState={currentState}
          onSubmitOrder={onSubmitOrder}
        />
      )}
    </ModalWrapper>
  );
};

export default OrderModal;
